import React from 'react';
import styles from './ProtectionDiv.css';

const ProtectionDiv = () => {
  return <div className={styles.protector} />;
};

export default ProtectionDiv;
